import { axiosInstance } from '../context/AuthContext';

export const checkoutApi = {
  createCheckoutSession: async ({ form, cartItems, returnBaseUrl, successPath, cancelPath }) => {
    const response = await axiosInstance.post('/checkout', {
      form,
      cartItems,
      returnBaseUrl,
      successPath,
      cancelPath,
    });
    return response.data;
  },

  confirmCheckout: async (sessionId) => {
    const response = await axiosInstance.get('/checkout/confirm', {
      params: { session_id: sessionId },
    });
    return response.data;
  },
};
